"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _accessControlHOC = _interopRequireDefault(require("access-control-lib/components/accessControlHOC"));

var _Conditions = _interopRequireDefault(require("access-control-lib/conditions/Conditions"));

var _selectors = require("settings-ui-sdk/Auth/selectors");

var _default = function _default(_ref) {
  var read = _ref.read,
      write = _ref.write;
  return function (Component) {
    var controlled = (0, _accessControlHOC.default)(Component, read);
    var name = Component.displayName || Component.name;
    controlled.displayName = "AccessControl(" + name + ")";

    var mapStateToProps = function mapStateToProps(state) {
      var gates = (0, _selectors.getUserGates)(state);
      var scopes = (0, _selectors.getUserScopes)(state);

      var writeAccess = _Conditions.default.shouldAccess(write)({
        gates: gates,
        scopes: scopes
      });

      return {
        gates: gates,
        readOnly: !writeAccess,
        scopes: scopes
      };
    };

    return (0, _reactRedux.connect)(mapStateToProps)(controlled);
  };
};

exports.default = _default;
module.exports = exports.default;